import { PRE_POPULATE_FORM } from 'root/src/client/logic/form/actionIds'

export default payload => ({
	type: PRE_POPULATE_FORM,
	payload,
})
